module.exports = __webpack_public_path__ + "img/весенние разливы 70х90.eb821684.jpg";